import React, {useState, useEffect} from 'react'
import cn from "classnames"
import pageBg from  '../../img/peaks-bg.webp'
import modalBg from '../../img/waterfall-modal-bg.svg'
import contentImg1 from '../../img/markov_2.webp'
import {Preloader, SpriteSvg} from '../../components'
import sun2 from "../../img/sun2.png";
import sun3 from "../../img/sun3.png";
import sun4 from "../../img/sun4.png";
import sun5 from "../../img/sun5.png";
import sun6 from "../../img/sun6.png";
import {useMousePosition} from '../../utils'
import bgImg1 from "../../img/peaks-bgImg1.webp";
import bgImg2 from "../../img/peaks-bgImg2.webp";
import bgImg3 from "../../img/peaks-bgImg3.webp";
import bgImg4 from "../../img/peaks-bgImg4.webp";

const PeacsPage = ({
	handleNextPage,
	name,
	isLoaded,
	setIsLoaded,
	isRouteTraveled,
	setIsRouteTraveled,
	peaksPage,
	afterPeaksGamePage,
}) => {

const [isVisibleContent, setIsVisibleContent] = useState(false)
const [isVisiblePage, setIsVisiblePage] = useState(true)
const [isVisibleGame, setIsVisibleGame] = useState(false)
const [modalContentChange, setModalContentChange] = useState('1')

	useEffect(()=> {
		window.TN_OXYGEN.run("#area");
		setTimeout(()=> {
			setIsVisibleContent(true)
		},7000)
	},[])

	const handleMeadowGame = () => {
		setIsVisiblePage(false)
		setIsVisibleGame(true)
		window.TN_OXYGEN.showStartMessage()
		window.TN_OXYGEN.successCallback = () => {
			setIsRouteTraveled([...isRouteTraveled, peaksPage])
			setIsVisibleGame(false)
			handleNextPage(afterPeaksGamePage)
		}
	}
	const position = useMousePosition()
	return (
		<>
		<Preloader isLoaded={isLoaded} setIsLoaded={setIsLoaded}/>
			<div id='area' className={cn(
				'game-wrap',
				isVisibleGame && 'active'
			)}></div>

			{isVisiblePage &&
		<div className={cn(
					 'full-page',
					 'peacs-page',
					 isLoaded && 'active'
				 )}
		>
			<div className="page-bg left-sun">
				<img className='bg-img' src={pageBg} alt=""/>
				<img className='sun2' style={{transform: `translate(-${position.x / 10}px, -${position.y / 10}px)`}} src={sun2} alt=""/>
				<img className='sun3' style={{transform: `translate(-${position.x / 25}px, -${position.y / 25}px)`}} src={sun3} alt=""/>
				<img className='sun4' style={{transform: `translate(-${position.x / 50}px, -${position.y / 50}px)`}} src={sun4} alt=""/>
				<img className='sun5'  src={sun5} alt=""/>
				<img className='sun6' style={{transform: `translate(${position.x / 150}px, ${position.y / 150}px) rotate(-91deg)`}} src={sun6} alt=""/>
				<img className='peacs-bgImg1' style={{transform: `translate(${position.x / 450}px, ${position.y / 450}px)`}} src={bgImg1} alt=""/>
				<img className='peacs-bgImg2' style={{transform: `translate(-${position.x / 350}px, -${position.y / 350}px)`}} src={bgImg2} alt=""/>
				<img className='peacs-bgImg3' style={{transform: `translate(${position.x / 450}px, ${position.y / 450}px)`}} src={bgImg3} alt=""/>
				<img className='peacs-bgImg4' style={{transform: `translate(${position.x / 150}px, ${position.y / 150}px)`}} src={bgImg4} alt=""/>
			</div>

			<div className={cn(
						 'page-content',
						 isVisibleContent &&
						 'active'
					 )}>

				<div className={cn(
					'modal',
					modalContentChange !== '1' &&
					'disabled'
				)}
				>
					<div className="modal-bg">
						<img src={modalBg} alt=""/>
					</div>


					<div className={cn(
						'modal-content'
					)}
					>
						<div className="text">
							<p className='mg-b-24'>Довольно быстро достигли хорошей высоты, чувствуешь, какой разреженный воздух? Думаю, стоит подготовить баллоны с кислородом, чтобы в пути не было проблем.</p>
								<p className='mg-b-24'>Постой, что у тебя с клапаном? Кислород уходит из баллона, беда! Ну что, повернём назад?</p>
						</div>

						<div className="btn-wrap jcs">
							<div onClick={()=> setModalContentChange('2')} className="btn green" style={{width: '190px'}}>
								<SpriteSvg id='train-station-page-btn-green-bg'/>
								<span>Только вперед</span>
							</div>
						</div>
					</div>

				</div>

				<div className={cn(
					'modal',
					modalContentChange !== '2' &&
					'disabled'
				)}
				>
					<div className="modal-bg">
						<img src={modalBg} alt=""/>
					</div>

					<div className={cn(
						'modal-content',
					)}
					>
						<div className="text">
							<p className='mg-b-16'>Я восхищён твоим упорством!</p>
							<p className='mg-b-16'>Ты довольно умело устраняешь утечку с помощью подручных средств, но этого хватит лишь до середины пути. Нужно заменить клапан, а после заправить баллон.</p>
							<p className='mg-b-16'>К счастью, мы можем взять клапан у девушек впереди. Они укрылись от ветра в скалах у горного озера.</p>

						</div>

						<div className="btn-wrap jcs">
							<div onClick={()=> setModalContentChange('3')}  className="btn green" style={{width: '190px'}}>
								<SpriteSvg id='train-station-page-btn-green-bg'/>
								<p>Установить новый клапан</p>
							</div>
						</div>
					</div>

				</div>


				<div className={cn(
					'modal',
					modalContentChange !== '3' &&
					'disabled'
				)}
				>
					<div className="modal-bg">
						<img src={modalBg} alt=""/>
					</div>

					<div className={cn(
						'modal-content',
					)}
					>
						<div className="text">
							<p className='mg-b-24'>Отлично, теперь твой баллон в норме, но требуется его заправить. Девушки подсказали, что рядом находится нужный нам аппарат, но с ним что-то не так — похоже, он сломан. Давай посмотрим, что можно сделать. Кстати, девушки показали ящик со старыми запчастями, возможно, это поможет.</p>
						</div>

						<div className="btn-wrap jcs">
							<div onClick={()=> handleMeadowGame()} className="btn green" style={{width: '190px'}}>
								<SpriteSvg id='train-station-page-btn-green-bg'/>
								<p>Заправиться кислородом</p>
							</div>
						</div>
					</div>

				</div>

				<div className={cn(
					'content',
					'center',
				)}>
					<div className="img-wrap">
						<img src={contentImg1} alt=""/>
					</div>

				</div>

			</div>

		</div>
			}
		</>
	)
}

export default PeacsPage